var React = require('react');

function PodcastStitcher (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.9733 9.25067H23.4947V22.7507H23.9733V9.25067ZM22.98 10.7507H22.5V21.2507H22.98V10.7507ZM21.492 10.7507H0V21.2507H21.492V10.7507ZM32 10.7507H25.9893V21.2507H32V10.7507ZM24.992 10.7507H24.512V21.2507H24.992V10.7507Z","fill":"#303030"}));
}

PodcastStitcher.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = PodcastStitcher;

PodcastStitcher.default = PodcastStitcher;
